/*
  Price_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { number, shape, string } from 'prop-types'

import PriceInfo_v1 from './PriceInfo_v1'

export default {
  info: shape(PriceInfo_v1),
  net: number,
  currency: string,
  amount: number,
  type: string,
}
